import { render } from "./ToggleResident.vue?vue&type=template&id=39d56980&scoped=true"
import script from "./ToggleResident.vue?vue&type=script&lang=js"
export * from "./ToggleResident.vue?vue&type=script&lang=js"

import "./ToggleResident.vue?vue&type=style&index=0&id=39d56980&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d56980"]])

export default __exports__